import { notImplemented, mod97CheckSum } from "../utils/general-helper";
import { IRegionFunctions, ParsedAccount } from "./region-functions";

const regionFunctionsDK: () => IRegionFunctions = () => {
	const accounNrExpression = RegExp(/^(\d{10,14})$/);
	const validPhonenNrExpression = RegExp(/(\+45|8)\d{1,2}[- ]?\d{2}[- ]?\d{2}[- ]?\d{2}$/);
	const basicIbanStructureRegEx = RegExp(/^(?=.{15,34}$)[A-Z]{2}[A-Z0-9]+$/);
	const registrationNumberLength = 4;
	const accountNumberMaxLength = 14;

	const validPhoneNumber = (phoneNumber: string): boolean => validPhonenNrExpression.test(phoneNumber);

	const formatPhoneNumber = (_phoneNumber: string): string => {
		return notImplemented();
	};

	const validateAccountNumber = (accountNumber: string): boolean => {
		const sanitizedAccountNr = accountNumber.replace(/ /g, "");
		return accounNrExpression.test(sanitizedAccountNr);
	};

	const getBankAccountMeta = (_accountNrIncludingClearing?: string) => {
		return {
			clearingNumberLength: registrationNumberLength,
			accountNumberMaxLength,
		};
	};

	const parseAccountNumber = (accountNrIncClearing: string): ParsedAccount => {
		const [clearingNumber, accountNumber] = accountNrIncClearing.includes(" ")
			? accountNrIncClearing.split(" ")
			: [
					accountNrIncClearing.slice(0, registrationNumberLength),
					accountNrIncClearing.slice(registrationNumberLength),
				];
		return { clearingNumber, accountNumber };
	};

	const formatAccountNumber = (clearingNr: string, accountNr: string) => {
		const sanitizedAccountNr = (clearingNr + accountNr).replace(/ /g, "");
		if (sanitizedAccountNr.length <= registrationNumberLength) return clearingNr;
		return `${clearingNr} ${accountNr}`;
	};

	const validateIban = (IBAN: string, allowedCountryCodes?: string): boolean => {
		if (IBAN.length < 1) return true;
		if (allowedCountryCodes && allowedCountryCodes !== "") {
			const ibanCountryCode = IBAN.substring(0, 2);
			if (!allowedCountryCodes.split(",").some((countryCode) => countryCode === ibanCountryCode))
				return false;
		}
		IBAN = IBAN.replace(/[\s]+/g, "").toUpperCase();
		if (!basicIbanStructureRegEx.test(IBAN)) return false;

		const rearrangedIban = IBAN.slice(4) + IBAN.slice(0, 4);
		const convertedIban = rearrangedIban.replace(/[A-Z]/g, (char) => (char.charCodeAt(0) - 55).toString());

		return mod97CheckSum(convertedIban);
	};

	return {
		validateIban,
		validateAccountNumber,
		validPhoneNumber,
		formatPhoneNumber,
		formatAccountNumber,
		parseAccountNumber,
		bankAccountMeta: getBankAccountMeta,
	};
};

export const DKRegionFunctions = regionFunctionsDK();
